import { render, staticRenderFns } from "./module-shuxing.vue?vue&type=template&id=418641ec&scoped=true"
import script from "./module-shuxing.vue?vue&type=script&lang=js"
export * from "./module-shuxing.vue?vue&type=script&lang=js"
import style0 from "./module-shuxing.vue?vue&type=style&index=0&id=418641ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418641ec",
  null
  
)

export default component.exports